interface MutateStatusCheckParams {
  statusCheckId: string
  teamId: string
}

export const statusChecksMutationKeys = {
  createStatusCheck: (teamId: string) => ['status-checks', { teamId }] as const,
  mutateStatusCheck: ({ statusCheckId, ...params }: MutateStatusCheckParams) =>
    [`status-checks/${statusCheckId}`, params] as const
}
